import { render, staticRenderFns } from "./Notif.vue?vue&type=template&id=461c1fa4&"
import script from "./Notif.vue?vue&type=script&lang=js&"
export * from "./Notif.vue?vue&type=script&lang=js&"
import style0 from "./Notif.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports